import { render, staticRenderFns } from "./addCustomDailog.vue?vue&type=template&id=3757cf88&scoped=true&"
import script from "./addCustomDailog.vue?vue&type=script&lang=js&"
export * from "./addCustomDailog.vue?vue&type=script&lang=js&"
import style0 from "./addCustomDailog.vue?vue&type=style&index=0&id=3757cf88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757cf88",
  null
  
)

export default component.exports